/* ds.js — behaviour for the Underpaw playful layer. No dependencies.
   Adapted from Kept Close's kc.js, then deliberately simplified: the pinned/scroll-jacked process
   sequence and its Ken-Burns pan driver are gone entirely (see ds.css for why — a held-scroll
   cinematic explainer is the wrong register for a quick, playful gift purchase; the process
   section is now a plain CSS strip with no JS behind it at all). Everything still degrades:
   without JS the content is visible (html.ds-js gates the hidden states), with
   prefers-reduced-motion nothing autoplays or animates. No video assets exist for this brand
   (supplier stock photography only), so the video-in-view / film-dialog / 3D-viewer modules from
   kc.js were already dropped. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal on view ---------- */
  function initReveal() {
    var els = [].slice.call(document.querySelectorAll('[data-ds-reveal]'));
    if (!els.length) return;
    els.forEach(function (el) {
      var d = parseFloat(el.getAttribute('data-ds-reveal'));
      if (!isNaN(d)) el.style.setProperty('--ds-d', d);
    });
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- pointer sheen ---------- */
  function initSheen() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches || reduce) return;
    [].slice.call(document.querySelectorAll('[data-ds-sheen]')).forEach(function (el) {
      var raf = 0;
      el.addEventListener('pointermove', function (ev) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var r = el.getBoundingClientRect();
          el.style.setProperty('--mx', ((ev.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          el.style.setProperty('--my', ((ev.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        });
      }, { passive: true });
    });
  }

  /* ---------- header shadow after scroll ---------- */
  function initHeader() {
    var on = false;
    var wrap = document.querySelector('.page-wrapper');
    function chk() {
      var y = Math.max(window.scrollY || 0, wrap ? wrap.scrollTop : 0);
      var s = y > 8;
      if (s !== on) { on = s; if (s) root.setAttribute('data-ds-scrolled', ''); else root.removeAttribute('data-ds-scrolled'); }
    }
    document.addEventListener('scroll', chk, { passive: true, capture: true });
    chk();
  }

  /* ---------- sticky mobile buy bar ---------- */
  function initBar() {
    var bar = document.querySelector('[data-ds-bar]');
    var box = document.querySelector('[data-ds-buybox]');
    if (!bar || !box || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    io.observe(box);
    var btn = bar.querySelector('[data-ds-bar-go]');
    if (btn) btn.addEventListener('click', function () {
      var app = document.querySelector('#mademine-node .__button');
      if (app) app.click();
      else box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function boot() {
    window.__dsReady = true;
    initReveal(); initSheen(); initHeader(); initBar();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
